module.exports = __webpack_public_path__ + "img/square-envelope.5322a033.svg";